import { useQuery } from '@tanstack/react-query';
import { nexusFetch } from '../../nexus/nexusClient';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';

/**
 * Produkt-Statistik Netfabric — Betreiber-Sicht, nur lesend. Endpunkte,
 * Tenants, Policy-Regeln (gesamt/aktiv), WireGuard-Netze & -Peers sowie die
 * Aufschlüsselung der Endpunkte nach kind. M2M-Auth wie alle /v1/admin/*.
 */
const FIXTURE = {
  endpoints: 214,
  tenants: 63,
  byKind: [
    { kind: 'service', n: 121 },
    { kind: 'gateway', n: 48 },
    { kind: 'external', n: 45 },
  ],
  rules: { total: 512, enabled: 487 },
  wgNetworks: 29,
  wgPeers: 176,
};

export function useNetfabricStats() {
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['product-stats-netfabric', fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) { await fixtureDelay(); return FIXTURE; }
      return nexusFetch('/v1/admin/product-stats/netfabric');
    },
    refetchInterval: 60_000,
  });
}
